import DocumentDownload from "../components/citizen-services/DocumentDownload";
import ComplaientForm from "../components/citizen-services/ComplaientForm";
import CustomTabs from "../components/CustomTabs";
import TaxPayment from "../components/citizen-services/TaxPayment";
import PageHeader from '../components/PageHeader';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import VillageIllustration from "../components/VillageIllustration";

const CitizenServices = () => {
  const { t } = useTranslation();

  const items = [
    { key: "1", label: t('citizenServices.tabs.documentDownload') || 'दस्तावेज डाउनलोड', children: <DocumentDownload /> },
    { key: "2", label: t('citizenServices.tabs.complaints') || 'तक्रारी आणि सल्ला', children: <ComplaientForm /> },
    { key: "3", label: t('citizenServices.tabs.taxPayment') || 'कर भरने', children: <TaxPayment /> },
  ];

  return (
    <>
      <div className="bg-image-section">
        <div className="flex flex-col gap-3 section-padding">
          <PageHeader
            breadcrumb={[
              <Link key="home" to="/">{t('home.breadcrumb')}</Link>,
              <span key="citizen-services">{t('citizenServices.breadcrumb')}</span>
            ]}
            title={t('citizenServices.title')}
            description={t('citizenServices.description')}
          />
          <CustomTabs items={items} />
        </div>
      </div>
      <VillageIllustration />
    </>
  );
};

export default CitizenServices;
